module.exports = __webpack_public_path__ + "static/media/icons-dashboard-earnings.2acee85c.svg";